var _require = require('crypto'),
    randomBytes = _require.randomBytes;

var _require2 = require('../registry'),
    IVLENGTHS = _require2.IVLENGTHS;

module.exports = function (alg) {
  return randomBytes(IVLENGTHS.get(alg) / 8);
};